export enum SortOptions {
  BestMatch = 'best',
  HighestRated = 'rating',
  Distance = 'distance',
  PriceAscending = 'price-asc',
  PriceDescending = 'price-desc',
}
